module.exports = __webpack_public_path__ + "static/media/websiteChef.9d55a1f9.png";